import request from '@/utils/request'
import { Message } from "element-ui";

//平台保证金---  查询商户申请保证金列表
export function historyApprovePage(data) {
  return request({
    url: '/shop/guarantee/platform/approve/page',
    method: 'post',
    data:data
  })
}
 
//平台保证金---  查询商户申请保证金列表
export function historyApprovePageOps(data) {
  return request({
    url: '/shop/guarantee/merchant/ops/approvePage',
    method: 'post',
    data:data
  })
}

// 保证金 审核详情接口
export function guaranteeApproveInfo(data) {
  return request({
      url: "/shop/guarantee/merchant/approve/info",
      method: "GET",
      params: data,
  });
}

// 获取打款凭证信息
export function getCertInfo(data) {
  return request({
      url: "/shop/guarantee/merchant/approve/getCertInfo",
      method: "GET",
      params: data,
  });
}

//保证金--- 变动日志列表接口
export function userLogPage(data) {
  return request({
      url: "/payment/guarantee/merchant/ops/userLogPage",
      method: "post",
      data: data,
  });
}

// 平台保证金--- 查询商户申请保证金列表导出
export function approveExport(data) {
  return request({
    url: '/shop/guarantee/platform/approve/export',
    method: 'GET',
    parmas:data
  })
}

//平台保证金---  平台审核商户保证金
export function platformApprove(data) {
  return request({
    url: '/shop/guarantee/platform/approve',
    method: 'post',
    data:data
  })
}
  
//平台保证金---  详情接口
export function platformInfo(data) {
  return request({
    url: '/payment/guarantee/platform/info',
    method: 'GET',
    params:data
  })
}


// 审核详情
export function platformApproveInfo(data) {
  return request({
    url: '/shop/guarantee/platform/approve/info',
    method: 'GET',
    params:data
  })
}
// 查看凭证
export function payvoucherinfo(data) {
  return request({
    url: `/order/purchase/payvoucherinfo/ops`,
    method: "get",
    params:data
  });
}

// 查看凭证
export function payvoucherinfoDetail(data) {
  return request({
    url: `/order/purchase/order/voucher/relation/get/detail`,
    method: "get",
    params:data
  });
}


// 审核
export function check(data) {
  return request({
    url: `/order/purchase/payvoucherinfo/check`,
    method: "put",
    data
  });
}

// 保证金详情接口
export function guaranteeInfo(data) {
  return request({
      url: "/payment/guarantee/merchant/info",
      method: "GET",
      params: data,
  });
}

export function fileExport(apiUrl,methodType,data) {
  return request({
      url: apiUrl,
      method:methodType?methodType: "GET",
      data,
      responseType: "blob",
  }).then((response) => {
      // 处理返回的文件流
      const blob = response.data;
      if (blob && blob.size === 0) {
          Message.warning("内容为空，无法下载");
          return;
      }
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      const contentDisposition = response.headers["content-disposition"];
      const fileName = decodeURIComponent(
          contentDisposition.substring(contentDisposition.indexOf("=") + 1)
      );
      // console.log(fileName)
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      window.setTimeout(function () {
          URL.revokeObjectURL(blob);
          document.body.removeChild(link);
          Message.success("导出成功！");
      }, 0);
  });
}

// ops导出所有凭证信息
export function excel(data) {
  return request({
    url: `/order/purchase/payvoucherinfo/ops/excel`,
    method: "get",
    responseType: 'blob',
    params:data
  }).then(response => {
    // 处理返回的文件流
    const blob = response.data
    if (blob && blob.size === 0) {
      Message.warning('内容为空，无法下载')
      return
    }
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    const contentDisposition = response.headers['content-disposition'];
    const fileName = decodeURIComponent(contentDisposition.substring(contentDisposition.indexOf('=') + 1));
    console.log(fileName)
    link.download = fileName;
    document.body.appendChild(link)
    link.click()
    window.setTimeout(function() {
      URL.revokeObjectURL(blob)
      document.body.removeChild(link)
      Message.success('导出成功')
    }, 0)
  });
}
